var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_body"},[_c('div',{staticClass:"data_main"},[_c('div',{staticClass:"data_group"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.postParam}},[_vm._v("更新")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }